export default __webpack_public_path__ + "static/neue-haas-grotesk-text-65-medium-0e36d5c39dfe43e618ab4013620416bf.woff";